/**
 * Shared Application Constants
 * Centralizes magic numbers and configuration values
 */

// Pagination
export const PAGINATION = {
  WIDGETS_PER_PAGE: 9,
  CONVERSATIONS_PER_PAGE: 20,
  ANALYTICS_RECENT_LIMIT: 5,
  MAX_CLIENT_SIDE_WIDGETS: 100, // Backend limit - beyond this, implement server-side filtering
};

// Analytics Display
export const ANALYTICS = {
  DAILY_USAGE_TABLE_LIMIT: 10, // Max days to show in daily usage table
};

// Date Ranges
export const DATE_RANGES = {
  DEFAULT_ANALYTICS_DAYS: 30,
  MAX_ANALYTICS_DAYS: 365,
};

// Navigation route paths — single source of truth for link targets used across
// multiple components. Keeps route strings out of individual page/view files.
// All values are strings. Dynamic path builders live in utils/navigation.js.
export const ROUTES = {
  LANDING: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  VERIFY_EMAIL: "/verify-email",
  // Routing policy: where authenticated users land after being redirected away
  // from a public-only page (DefaultRedirect, PublicRoute, ProtectedRoute role
  // check).  Kept here (not in AUTH) so all routing decisions live together.
  // This is also the canonical dashboard path — use AUTHENTICATED_HOME everywhere
  // rather than a separate DASHBOARD constant to keep a single source of truth.
  AUTHENTICATED_HOME: "/dashboard",
};

// Retry Configuration
export const RETRY = {
  MAX_ATTEMPTS: 3, // Maximum retry attempts before giving up
  DEBOUNCE_MS: 2000, // Minimum time between retry attempts (prevents rapid clicking)
  BASE_DELAY_MS: 1000, // Base delay for exponential backoff
  MAX_DELAY_MS: 30000, // Maximum delay between retries
};

// Local Storage Keys.
// Tokens are stored in httpOnly cookies by the server — they never appear in
// localStorage.  Only non-sensitive state (user profile, UI preferences) lives
// here so the frontend can make routing decisions without making an API call.
export const STORAGE_KEYS = {
  USER: "user",
  SEARCH_WARNING_SHOWN: "search_warning_shown_session",
};

// Form Validation
export const VALIDATION = {
  MAX_WIDGET_NAME_LENGTH: 255,
  MAX_MESSAGE_LENGTH: 2000,
  MIN_MESSAGE_LENGTH: 1,
};
